export const ROLE = {
  ADMIN: 'admin',
  MERCHANT: 'merchant',
  PARTNER: 'partner',
  SUPER_ADMIN: 'super_admin',
}
